import { graphql } from 'relay-runtime';

export const ATLASSIAN_PRODUCTS_FRAGMENT = graphql`
  fragment AtlassianProductsFragment on UnifiedAtlassianProductConnection {
    edges {
      cursor
      node {
        id
        productId
        title
        type
        viewHref
      }
    }
    totalCount
  }
`;
